import { Component, Input } from '@angular/core';

import { PhcThumbnail } from "../../classes/phc-app/phc-app";




/**
 * Generated class for the PhcImgComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'phc-thumbnail',
  templateUrl: 'phc-thumbnail.html'
})
export class PhcThumbnailComponent {

  @Input()
  thumbnail: PhcThumbnail;

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/components/phc-thumbnail/phc-thumbnail.ts